<div class="ag-cell-editor fx-layout-row fx-justify-space-between fx-align-center">
  <input [formControl]="control" matInput type="datetime-local" matIconSuffix/>

  @if (control.invalid) {
    <div>
      <i class="mdi mdi-help-circle tooltip-icon" [matTooltip]="errorTooltip"></i>
    </div>
  }

  <div>
    <i class="mdi mdi-check" (click)="stopEditing()"></i>
  </div>
</div>
